"use client";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "../Images/owisionlogo.png";
import { Link, useLocation } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(false);
  const [activeLink, setActiveLink] = useState("/");
  const [showServiceMenu, setShowServiceMenu] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  const currentLanguage = i18n.language;

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      if (window.scrollY < lastScrollY) {
        setVisible(true);
      } else {
        setVisible(false);
      }
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    setActiveLink(location.pathname);
    setOpenMenu(false); // Close the mobile menu on route change
  }, [location]);

  return (
    <div
      className={`navbar_container ${
        window.innerWidth >= 768
          ? `transition-transform duration-300 ${visible ? "translate-y-0" : "-translate-y-full"}`
          : ""
      }`}
      style={{ zIndex: "111111", position: "fixed", top: 0, width: "100%" }}
    >
      <div className="navbar_wrapper">
        <div className="navbar_logo">
          <Link to="/">
            <img alt="Owision AB Logo" src={Logo} />
          </Link>
        </div>
        <div className="menu_toggle">
          <div className={openMenu ? "menu_link menu-link-active" : "menu_link"}>
            <Link to="/" className={activeLink === `/` ? "list-item active_blue" : "list-item"}>
              <span>Home</span>
            </Link>
            <Link
              to="/service"
              className={activeLink === `/service` ? "list-item active_blue" : "list-item"}
            >
              <span>Services</span>
            </Link>
            <a
              href="https://skillioz.ai/career/0f4af31cd1be53f7/owision"
              className="list-item"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpenMenu(false)}
            >
              <span>Careers</span>
            </a>
            <Link
              to="/about"
              className={activeLink === `/about` ? "list-item active_blue" : "list-item"}
            >
              <span>About Us</span>
            </Link>
            <Link
              to="/contact"
              className={activeLink === `/contact` ? "list-item active_blue" : "list-item"}
            >
              <span>Contact</span>
            </Link>
          </div>
          {openMenu === false ? (
            <svg
              onClick={() => setOpenMenu(true)}
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="#303F7A"
              className="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
              />
            </svg>
          ) : (
            <span onClick={() => setOpenMenu(false)}>
              <RxCross2 size={30} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
